/* eslint-disable import/no-anonymous-default-export */
import http from "./httpService";
import { MoodProps, UpdateMoodProps } from "../typings/mood";
import { default as apiConfing } from "../config.json";
import { AxiosResponse } from "axios";

const apiUrl = apiConfing.IS_DEVELOPMENT ? apiConfing.API_DEVELOPMENT : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/Mood`;


export function getMoodsOption(languageId: number): Promise<AxiosResponse<MoodProps[]>> {
  const url = `${apiEndpoint}/GetMoodsOption?languageId=${languageId}`
  return http.get(url);
}

export function updateMemberMood(moodUpdate: UpdateMoodProps) {
  const url = `${apiEndpoint}/UpdateMemberMood`
  return http.put(url, moodUpdate);
}


export default {
  getMoodsOption,
  updateMemberMood,
};
